import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AppConfigService } from "@core/services/app-config.service";
import { ContactDetailsPersistentModel } from '@shared/models/contact-details-persistent-model';
import { SubSink } from "subsink";
import {AppConfig} from '@core/models/app-config';

@Component({
	selector: "cass-contact-details",
	templateUrl: "./contact-details.component.html",
	styleUrls: ["./contact-details.component.css"]
})
export class ContactDetailsComponent implements OnInit, OnDestroy {

	@Input()
	parentForm!: FormGroup;

	@Input()
	allowIntrinsicAccountCreation = false;

	_showCountry: boolean = false;
	showStateField: boolean = false;
	isAddress2FieldMandatory: boolean = false;

	@Input()
	set initialDetails(contactDetails: ContactDetailsPersistentModel | undefined) {
		// This property can be set before and after the form creation
		if (contactDetails) {
			this._initialDetails = contactDetails;
			if (this.form) {
				this.setFormValueIfNotEmpty("firstName", contactDetails.firstName);
				this.setFormValueIfNotEmpty("lastName", contactDetails.lastName);
				this.setFormValueIfNotEmpty("address1", contactDetails.address1);
				this.setFormValueIfNotEmpty("address2", contactDetails.address2);
				this.setFormValueIfNotEmpty("city", contactDetails.city);
				this.setFormValueIfNotEmpty("state", contactDetails.state);
				this.setFormValueIfNotEmpty("country", contactDetails.country);
				this.setFormValueIfNotEmpty("zipcode", contactDetails.zipcode);
				this.setFormValueIfNotEmpty("phone", contactDetails.phone);
				this.setFormValueIfNotEmpty("email", contactDetails.email);
			}
		}
	}


	@Input()
	set showCountry(value: boolean) {
		this._showCountry = value;
		if (this._showCountry === true) {
			this.country = this.formBuilder.control(this._initialDetails?.country || "", [Validators.maxLength(3)]);
		} else {
			this.country = this.formBuilder.control(this._initialDetails?.country || "");

		}
	}
	private _initialDetails?: ContactDetailsPersistentModel = undefined;

	form!: FormGroup;

	firstName: FormControl;
	lastName: FormControl;
	address1: FormControl;
	address2: FormControl;
	city: FormControl;
	state: FormControl;
	country!: FormControl;
	zipcode: FormControl;
	phone: FormControl;
	email: FormControl;
	password!: FormControl;

	constructor (private formBuilder: FormBuilder, private appConfigService: AppConfigService) {
		this.firstName = this.formBuilder.control(this._initialDetails?.firstName || "", [Validators.required, Validators.maxLength(100)]);
		this.lastName = this.formBuilder.control(this._initialDetails?.lastName || "", [Validators.required, Validators.maxLength(100)]);
		this.address1 = this.formBuilder.control(this._initialDetails?.address1 || "", [Validators.required, Validators.maxLength(100)]);
		this.address2 = this.formBuilder.control(this._initialDetails?.address2 || "", [Validators.maxLength(100)]);
		this.city = this.formBuilder.control(this._initialDetails?.city || "", [Validators.required, Validators.maxLength(100)]);
		this.state = this.formBuilder.control(this._initialDetails?.state || "");
		this.country = this.formBuilder.control(this._initialDetails?.country || "");
		this.zipcode = this.formBuilder.control(this._initialDetails?.zipcode || "", [Validators.required, Validators.maxLength(12)]);
		this.phone = this.formBuilder.control(this._initialDetails?.phone || "", [Validators.required, Validators.maxLength(26)]);
		this.email = this.formBuilder.control(this._initialDetails?.email || "", [Validators.required, Validators.email, Validators.maxLength(254)])
		this.password = this.formBuilder.control("", Validators.required);
	}

	allowAccountCreation = false;
	showPasswordField = false;

	protected isPasswordShown = false;

	private subs = new SubSink();

	ngOnInit(): void {

		this.subs.add(
			this.appConfigService.config$.subscribe((config) => {
				if (config) {
					this.configureComponent(config);
				}
			})
		);

		this.form = this.parentForm;
		this.form.addControl("firstName", this.firstName);
		this.form.addControl("lastName", this.lastName);
		this.form.addControl("address1", this.address1);
		this.form.addControl("address2", this.address2);
		this.form.addControl("city", this.city);
		this.form.addControl("state", this.state);
		this.form.addControl("country", this.country);
		this.form.addControl("zipcode", this.zipcode);
		this.form.addControl("phone", this.phone);
		this.form.addControl("email", this.email);
		this.form.addControl("createAccount", this.formBuilder.control(false));

		if (this.showPasswordField) {
			this.form.addControl("password", this.password);
		}
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	createAccountChanged() {
		if (this.form.get("createAccount")?.value) {
			this.showPasswordField = true;
			this.form.addControl("password", this.password);
		}
		else {
			this.showPasswordField = false;
			this.form.removeControl("password");
		}
	}

	private setFormValueIfNotEmpty(fieldName: string, fieldValue?: string) {
		if (this.form && fieldValue) {
			this.form.controls[fieldName].setValue(fieldValue);
		}
	}

	private configureComponent(appConfig: AppConfig) {

		this.allowAccountCreation = appConfig.registrationEnabled && this.allowIntrinsicAccountCreation;

		if (appConfig.contactDetailsAddress2FieldMandatory) {
			this.makeAddress2FieldMandatory();
		}

		if (appConfig.contactDetailsStateFieldEnabled) {
			this.showStateField = true
		}
	}

	/**
	 * Makes the Address 2 form field mandatory by adding the Validators.required
	 */
	private makeAddress2FieldMandatory() {
		this.address2.addValidators(Validators.required);
		this.address2.updateValueAndValidity();
	}
}
